const CLIENT_ID_KEY = 'brand_studio_client_token_v2';

function getClientId() {
  try {
    const existing = String(localStorage.getItem(CLIENT_ID_KEY) || '').trim();
    if (existing) return existing;
  } catch {
    // ignore
  }

  const next =
    (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function'
      ? crypto.randomUUID()
      : `${Date.now()}-${Math.random().toString(16).slice(2)}`);
  try {
    localStorage.setItem(CLIENT_ID_KEY, next);
  } catch {
    // ignore
  }
  return next;
}

export async function loadCloudState() {
  const clientId = getClientId();
  try {
    const res = await fetch('/api/state', { headers: { authorization: `Bearer ${clientId}` } });
    if (!res.ok) return null;
    const payload = await res.json();
    const state = payload?.state || {};
    return {
      history: Array.isArray(state.history) ? state.history : [],
      brands: Array.isArray(state.brands) ? state.brands : [],
      activeBrandId: String(state.activeBrandId || '').trim(),
    };
  } catch {
    return null;
  }
}

export async function saveCloudState(state) {
  const clientId = getClientId();
  const body = {
    state: {
      history: Array.isArray(state?.history) ? state.history : [],
      brands: Array.isArray(state?.brands) ? state.brands : [],
      activeBrandId: String(state?.activeBrandId || '').trim(),
    },
  };
  try {
    const res = await fetch('/api/state', {
      method: 'PUT',
      headers: { 'content-type': 'application/json', authorization: `Bearer ${clientId}` },
      body: JSON.stringify(body),
    });
    return res.ok;
  } catch {
    return false;
  }
}
